let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("53fst")).then(() => parcelRequire('135mT'));